const menuItemsAdmin = [
    {
        label : 'Partite',
        icon : 'football',
        route : 'admin.matches.list'
    },
    {
        label : 'Admin',
        icon : 'royal-crown-outline-for-a-prince',
        route : 'admin.users.list'
    },
    {
        label : 'Società',
        icon : 'football-club',
        route : 'admin.societies.list'
    },
    {
        label : 'Anagrafica',
        icon : 'group',
        route : 'admin.contacts.list'
    },
    {
        label : 'Richieste',
        icon : 'star',
        route : 'admin.requests.list'
    },
    {
        label : 'Archivio Richieste',
        icon : 'star',
        route : 'admin.requests.archive.list'
    },
    {
        label : 'Notifiche',
        icon : 'notification',
        route : 'admin.notices.list'
    },
    {
        label : 'Mailing',
        icon : 'mail',
        route : 'admin.mailings.list'
    },

];

export default menuItemsAdmin
